import { createSlider, syncSlides } from '@/utils/slider';

function placeArrows(swiper) {
    const image = swiper.el.querySelector('.child-destinations__media');
    const height = image?.getBoundingClientRect().height ?? 0;
    if (height > 0) {
        swiper.el.parentElement?.style.setProperty('--child-destinations-media', `${height}px`);
    }
}

document.querySelectorAll('[data-child-destinations]').forEach((root) => {
    if (root.dataset.childDestinationsReady === 'true') {
        return;
    }
    const viewport = root.querySelector('[data-child-destinations-slider]');
    if (!viewport) {
        return;
    }
    root.dataset.childDestinationsReady = 'true';
    root.classList.add('is-ready');

    const swiper = createSlider(viewport, {
        prev: root.querySelector('[data-child-destinations-prev]'),
        next: root.querySelector('[data-child-destinations-next]'),
        keyboard: { pageUpDown: false },
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        breakpoints: {
            601: { slidesPerView: 2, spaceBetween: 20 },
            1001: { slidesPerView: 4, spaceBetween: 20 },
        },
        watchSlidesProgress: true,
        roundLengths: true,
        grabCursor: true,
    });

    const reveal = () => syncSlides(viewport.querySelectorAll('[data-child-destinations-slide]'), {
        visible: true,
        inertOn: 'controls',
    });
    swiper.on('slideChange', reveal);
    swiper.on('slideChangeTransitionEnd', reveal);
    const paint = () => {
        placeArrows(swiper);
        reveal();
    };
    swiper.on('resize', paint);
    swiper.on('breakpoint', paint);
    paint();
    requestAnimationFrame(paint);
});
